import { useState } from "react";
import classNames from "classnames";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import { InputProps } from "@/app/types/props/forms/InputProps";
import { FieldValues, Path } from "react-hook-form";

function Input<TFormValues extends FieldValues = FieldValues>({
  label,
  name,
  register,
  rules,
  error,
  type = "text",
  placeholder,
  disabled,
  className,
  value,
  onChange,
  min,
  max,
  onInput,
}: InputProps<TFormValues>) {
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordType = type === "password";

  const inputProps = register ? register(name as Path<TFormValues>, rules) : { value, onChange };

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={name} className="mb-1 inline-block font-medium text-gray-500">
          {label}
        </label>
      )}
      <div className="relative w-full">
        <input
          {...inputProps}
          type={isPasswordType ? (showPassword ? "text" : "password") : type}
          id={name}
          placeholder={placeholder}
          disabled={disabled}
          min={min}
          max={max}
          onInput={onInput}
          className={classNames(
            "w-full rounded-lg border bg-white p-3 text-sm",
            "transition-all duration-200",
            "focus:ring-blue/20 focus:border-blue outline-none focus:ring-2",
            {
              "border-red-500": error,
              "border-gray-200": !error,
              "pr-12": isPasswordType,
              "cursor-not-allowed opacity-60": disabled,
            },
            className
          )}
        />
        {isPasswordType && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
          >
            {showPassword ? <FaEyeSlash className="h-5 w-5" /> : <FaEye className="h-5 w-5" />}
          </button>
        )}
      </div>
      {error?.message && <p className="mt-1 text-sm text-red-500">{error.message}</p>}
    </div>
  );
}

export default Input;
